<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>
  <!-- Step 1: General Information -->
  <mat-step label="I. Opći podaci o prijavitelju">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">I. Opći podaci o prijavitelju</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (generalInfoFieldValues.length > 0) {
          @for (field of generalInfoFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2: Activity Information -->
  <mat-step label="II. Podaci o aktivnosti">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">II. Podaci o aktivnosti</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (activityInfoFieldValues.length > 0) {
          @for (field of activityInfoFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 3: Justification Information -->
  <mat-step label="III. Obrazloženje">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">III. Obrazloženje</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (justificationFieldValues.length > 0) {
          @for (field of justificationFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 4: Budget Plan -->
  <mat-step label="IV. Plan proračuna">
    @if (allocation && allocation.budgetPlan) {
      <!-- Direct Costs -->
      <h3>POGLAVLJE A) IZRAVNI TROŠKOVI</h3>
      @for (budgetItem of directBudgetItems; track budgetItem; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ budgetItem.description }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ budgetItem.amountRequested | currency:'EUR'  }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ budgetItem.totalAmount | currency:'EUR' }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ budgetItem.explanation }}</p>
              @if (budgetItemFileMap[budgetItem.id.toString()] && budgetItemFileMap[budgetItem.id.toString()].length > 0) {
                <p><strong>Dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[budgetItem.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno POGLAVLJE A) IZRAVNI TROŠKOVI (traženo / ukupno):
          {{ allocation.budgetPlan.totalDirectCostsRequested | currency:'EUR' }} / {{ allocation.budgetPlan.totalDirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
      <!-- Indirect Costs -->
      <h3>POGLAVLJE B) NEIZRAVNI TROŠKOVI</h3>
      @for (budgetItem of indirectBudgetItems; track budgetItem; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Opis:</strong> {{ budgetItem.description  }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ budgetItem.amountRequested | currency:'EUR' }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ budgetItem.totalAmount | currency:'EUR'  }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ budgetItem.explanation  }}</p>
              @if (budgetItemFileMap[budgetItem.id.toString()] && budgetItemFileMap[budgetItem.id.toString()].length > 0) {
                <p><strong>Dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[budgetItem.id.toString()]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno POGLAVLJE B) NEIZRAVNI TROŠKOVI (traženo / ukupno):
          {{ allocation.budgetPlan.totalIndirectCostsRequested | currency:'EUR' }} / {{ allocation.budgetPlan.totalIndirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
      <!-- Total Costs -->
      <div class="totals">
        <h3>SVEUKUPNO (A + B) (traženo / ukupno):
          {{ allocation.budgetPlan.totalCostsRequested | currency:'EUR' }} / {{ allocation.budgetPlan.totalCostsActual | currency:'EUR' }}
        </h3>
      </div>
      <!-- Funding Sources -->
      <h3>OSTALI IZVORI FINANCIRANJA</h3>
      @for (fundingSource of allocation.budgetPlan.fundingSources; track fundingSource; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Vrsta izvora:</strong> {{ getFundingSourceTypeLabel(fundingSource.type) }}</p>
              <p><strong>Iznos:</strong> {{ fundingSource.amount | currency:'EUR' }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
      <!-- Total Funding from Other Sources -->
      <div class="totals">
        <h4>SVEUKUPNO (I + II + III + IV): {{ allocation.budgetPlan.totalFundingFromOtherSources | currency:'EUR' }}</h4>
      </div>
      <!-- Total Funding -->
      <div class="totals">
        <h3>SVEUKUPNI IZNOS TROŠKOVA PROGRAMA / PROJEKTA - SVI IZVORI: {{ allocation.budgetPlan.totalFunding | currency:'EUR' }}</h3>
      </div>
    }
  </mat-step>

  <!-- Step 5: Dokumenti -->
  <mat-step label="V. Dokumenti">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">VI. Dokumenti</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (allocationFiles && allocationFiles.length > 0) {
          <p><strong>Priloženi dokumenti:</strong></p>
          <ul>
            @for (file of allocationFiles; track file) {
              <li>
                <a (click)="downloadFile(file)" class="download-link">
                  {{ file.name }}
                </a>
              </li>
            }
          </ul>
        } @else {
          <p>Nema dokumenata.</p>
        }

      </mat-card-content>
    </mat-card>
  </mat-step>
</mat-stepper>
